<template>
    <div v-if="!loadingPage">
        <h3 class="mb-2 text-primary mt-50">فعال‌سازی درگاه پرداخت</h3>
        <b-card v-for="(item, index) in activationPaymentGateway" :key="index" no-body v-if="status == item.status"
            :class="item.bgColor" class="text-center text-white p-1 mb-1">
            <div> {{ item.text }}</div>
        </b-card>

        <b-alert v-if="rejectionReason && status == 2" variant="primary" show>
            <div class="alert-body text-center mb-50"> دلیل رد : {{ rejectionReason }}</div>
        </b-alert>

        <div class="pb-1">
            <b-card>
                <validation-observer #default="{ invalid }">
                    <b-form class="row auth-login-form" @submit.prevent>

                        <!-- type -->
                        <b-form-group label="نوع شخص" label-for="typeGatewayId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider name="نوع شخص" rules="required">
                                <v-select v-model="form.type" :disabled="status == 1 || status == 0" dir="rtl"
                                    :options="typeGateway" :searchable="false" autocomplete="off" id="typeGatewayId"
                                    :reduce="(value) => value.id" label="name" :clearable="false">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </validation-provider>
                        </b-form-group>

                        <!-- nationalId -->
                        <b-form-group v-if="form.type == 1" label="شناسه ملی" label-for="nationalIdId"
                            class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="شناسه ملی" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="ltr" id="nationalIdId"
                                    v-model="form.nationalId" name="nationalId"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>


                        <!-- nationalCode -->
                        <b-form-group v-if="form.type == 0" label="کد ملی" label-for="nationalCodeId"
                            class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="کد ملی" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="rtl" id="nationalCodeId"
                                    v-model="form.nationalCode" name="nationalCode"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- firstName -->
                        <b-form-group label="نام" label-for="firstNameId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="rtl" id="firstNameId"
                                    v-model="form.firstName" name="firstName"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- lastName -->
                        <b-form-group label="نام خانوادگی" label-for="lastNameId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="نام خانوادگی" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="rtl" id="lastNameId"
                                    v-model="form.lastName" name="lastName"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- phoneNumber -->
                        <b-form-group label="شماره همراه" label-for="phoneNumberId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="شماره همراه" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="rtl" id="phoneNumberId"
                                    v-model="form.phoneNumber" name="phoneNumber"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- fatherName -->
                        <b-form-group label="نام پدر" label-for="fatherNameId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="نام پدر" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="rtl" id="fatherNameId"
                                    v-model="form.fatherName" name="fatherName"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>


                        <!-- birthDate -->
                        <b-form-group label="تاریخ تولد" label-for="birthDateId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="تاریخ تولد" rules="required">
                                <b-form-input id="birthDateId" :disabled="status == 1 || status == 0"
                                    class="text-center main-input font-weight-bolder pointer"
                                    :value="form.birthDate ? new Date(form.birthDate).toLocaleDateString('fa-IR') : null"
                                    name="birthDateId" />
                            </validation-provider>
                        </b-form-group>
                        <date-picker v-model="form.birthDate" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#birthDateId" />


                        <!-- birthCertificateNumber -->
                        <b-form-group label="شماره شناسنامه" label-for="birthCertificateNumberId"
                            class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="شماره شناسنامه" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="ltr"
                                    id="birthCertificateNumberId" v-model="form.birthCertificateNumber"
                                    name="birthCertificateNumber"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- birthCertificateSeries -->
                        <b-form-group label="سریال شناسنامه" label-for="birthCertificateSeriesId"
                            class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="سریال شناسنامه" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="ltr"
                                    id="birthCertificateSeriesId" v-model="form.birthCertificateSeries"
                                    name="birthCertificateSeries"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!------------ province ------------>
                        <b-form-group label="استان" class="col-12 col-md-6 col-lg-4 mb-2">
                            <validation-provider name="استان" rules="required">
                                <v-select v-model="form.provinceId" :disabled="status == 1 || status == 0" dir="rtl"
                                    :options="provinces" :reduce="(val) => val.id" placeholder="انتخاب استان"
                                    label="name" :clearable="false" @input="onSelectProvince">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </validation-provider>
                        </b-form-group>

                        <!------------ city ------------>
                        <b-form-group v-if="form.provinceId" label="شهر" class="col-12 col-md-6 col-lg-4 mb-2">
                            <validation-provider name="شهر" rules="required">
                                <v-select v-model="form.cityId" :disabled="status == 1 || status == 0" dir="rtl"
                                    :options="selectedCities(form.provinceId)" placeholder="انتخاب شهر" label="name"
                                    :reduce="(val) => val.id" :clearable="false">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </validation-provider>
                        </b-form-group>


                        <!-- landlinePhone -->
                        <b-form-group label="تلفن ثابت" label-for="landlinePhoneId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="تلفن ثابت" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="ltr" id="landlinePhoneId"
                                    v-model="form.landlinePhone" name="landlinePhone"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- email -->
                        <b-form-group label="ایمیل" label-for="emailId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="ایمیل" rules="required|email">
                                <b-form-input :disabled="status == 1 || status == 0" dir="ltr" id="emailId"
                                    v-model="form.email" name="email"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- bankKey -->
                        <b-form-group label="نام بانک" label-for="bankKeyId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider name="نام بانک" rules="required">
                                <v-select v-model="form.bankKey" :disabled="status == 1 || status == 0" name="نام بانک"
                                    dir="rtl" :options="banks" autocomplete="off" id="bankKeyId"
                                    :reduce="(value) => value.key" label="name" :clearable="false">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </validation-provider>
                        </b-form-group>

                        <!-- cardNumber -->
                        <b-form-group label="شماره حساب" label-for="cardNumberId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="شماره حساب" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="ltr" id="cardNumberId"
                                    v-model="form.cardNumber" name="cardNumber"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- shabaNumber -->
                        <b-form-group label="شماره شبا" label-for="shabaNumberId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="شماره شبا" rules="required|shabaNumber">
                                <b-form-input :disabled="status == 1 || status == 0" dir="ltr" id="shabaNumberId"
                                    v-model="form.shabaNumber" name="shabaNumber"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- companyRegistrationNumber -->
                        <b-form-group v-if="form.type == 1" label="شماره ثبت شرکت"
                            label-for="companyRegistrationNumberId" class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="شماره ثبت شرکت" rules="required">
                                <b-form-input :disabled="status == 1 || status == 0" dir="ltr"
                                    id="companyRegistrationNumberId" v-model="form.companyRegistrationNumber"
                                    name="companyRegistrationNumber"
                                    class="text-center font-weight-bolder user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- companyRegistrationDate -->
                        <b-form-group v-if="form.type == 1" label="تاریخ ثبت شرکت" label-for="companyRegistrationDateId"
                            class="col-12 col-md-6 col-lg-4">
                            <validation-provider #default="{ errors }" name="تاریخ ثبت شرکت" rules="required">
                                <b-form-input id="companyRegistrationDateId" :disabled="status == 1 || status == 0"
                                    class="text-center main-input font-weight-bolder pointer"
                                    :value="form.companyRegistrationDate ? new Date(form.companyRegistrationDate).toLocaleDateString('fa-IR') : null"
                                    name="companyRegistrationDateId" />
                            </validation-provider>
                        </b-form-group>
                        <date-picker v-model="form.companyRegistrationDate" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#companyRegistrationDateId" />

                        <div class="col-12 mt-2">
                            <div class="d-flex justify-content-md-end justify-content-center">
                                <b-button @click="sendingEconomicInfo"
                                    :disabled="invalid || loading || status == 1 || status == 0" type="submit"
                                    variant="primary" class="px-5">
                                    ارسال
                                </b-button>
                            </div>
                        </div>
                    </b-form>
                </validation-observer>
            </b-card>
        </div>
    </div>
</template>

<script>
import { BRow, BCol, BButton, BCard, BCardText, BForm, BFormGroup, BSpinner, BFormInput, BCardBody, BAlert } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email, shabaNumber } from '@validations';
import { storeService } from '@core/services';
import vSelect from 'vue-select';
import { default as locations } from '@/@core/data/provinces';

export default {
    components: {
        vSelect,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BCard,
        BCardText,
        BCardBody,
        BButton,
        BForm,
        BSpinner,
        ValidationProvider,
        ValidationObserver,
        BAlert
    },
    data() {
        return {
            required,
            email,
            storeId: null,
            status: null,
            rejectionReason: null,
            loadingPage: true,
            loading: false,
            currentDate: '',
            typeGateway: [
                { id: 0, name: 'حقیقی' },
                { id: 1, name: 'حقوقی' },
            ],
            activationPaymentGateway: [
                {
                    text: 'برای فعال‌سازی درگاه پرداخت، لطفا فرم زیر را تکمیل و ارسال کنید. در صورت نداشتن مغایرت در اطلاعات ارسال شده، درگاه پرداخت شما طی ۳ تا ۵ روز کاری فعال خواهد شد.',
                    bgColor: 'bg-secondary',
                    status: null,

                },
                {
                    text: 'فرم با موفقیت ارسال شده و در حال بررسی است. نتیجه در همین صفحه اعلام خواهد شد. در صورت نداشتن مغایرت در اطلاعات ارسال شده، درگاه پرداخت شما طی ۳ تا ۵ روز کاری فعال خواهد شد.',
                    bgColor: 'bg-info',
                    status: 0,

                },
                {
                    text: 'درخواست فعال‌سازی درگاه پرداخت شما تایید شد. اکنون می‌توانید درگاه خود را از طریق صفحه "تنظیمات پایه" در بخش "سفارش‌گیری"، فعال کنید.',
                    bgColor: 'bg-success',
                    status: 1,

                },
                {
                    text: 'درخواست فعال‌سازی درگاه پرداخت شما رد شد است. لطفا اطلاعات را بررسی کرده و مجددا فرم را ارسال کنید.',
                    bgColor: 'bg-warning',
                    status: 2,

                },
            ],
            provinces: [...locations],
            form: {
                type: null,
                cardNumber: null,
                shabaNumber: null,
                nationalId: null,
                birthDate: null,
                companyRegistrationDate: null,
                companyRegistrationNumber: null,
                birthCertificateSeries: null,
                birthCertificateNumber: null,
                bankKey: null,
                cityId: null,
                landlinePhone: null,
                email: null,
                fatherName: null,
                provinceId: null,
                firstName: null,
                lastName: null,
                phoneNumber: null,
                nationalCode: null
            },
            banks: []
        };
    },
    computed: {
        selectedCities() {
            return (id) => (id ? this.provinces.find((state) => state.id === id).cities : null);
        },
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        onSelectProvince() {
            this.form.cityId = null;
        },
        getEconomicInfo() {
            storeService.getEconomicInfo(this.storeId).then(({ data }) => {
                this.rejectionReason = data.rejectionReason
                this.status = data.status
                this.form.type = data.type
                this.form.cardNumber = data.cardNumber
                this.form.shabaNumber = data.shabaNumber
                this.form.nationalId = data.nationalId
                this.form.birthDate = data.birthDate
                this.form.companyRegistrationDate = data.companyRegistrationDate
                this.form.companyRegistrationNumber = data.companyRegistrationNumber
                this.form.birthCertificateSeries = data.birthCertificateSeries
                this.form.birthCertificateNumber = data.birthCertificateNumber
                data.bank ? this.form.bankKey = data.bank.key : null
                data.city ? this.form.cityId = data.city.id : null
                data.province ? this.form.provinceId = data.province.id : null
                this.form.landlinePhone = data.landlinePhone
                this.form.email = data.email
                this.form.fatherName = data.fatherName
                this.form.firstName = data.firstName
                this.form.lastName = data.lastName
                this.form.phoneNumber = data.phoneNumber
                this.form.nationalCode = data.nationalCode
                this.getBanks()
            })
        },
        async getBanks() {
            await this.$axios.get(`/store/banks`).then(({ data }) => {
                this.banks = data.items;
                this.loadingPage = false
            })
        },
        sendingEconomicInfo() {
            this.loading = true
            this.loadingPage = true
            storeService.sendingEconomicInfo(this.storeId, this.form).then(({ data }) => {
                this.loading = false
                this.getEconomicInfo()
            })
                .catch(() => {
                    this.loadingPage = false
                    this.loading = false
                });
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const today = new Date();
        this.currentDate = this.formatDate2(today);
        this.getEconomicInfo()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>